<aside
  *transloco="let t; read: TRANSLATION_SCOPE"
  class="navigation"
  rxApplicationsPageScroll
  routerLinkActive="active"
>
  @defer (on viewport) {
    <ul class="nav flex-column" [attr.data-qa]="testIdPrefix">
      @if (authApiFacade.isAdmin()) {
        @if (selfUserManagementEnabled()) {
          <li class="nav-item">
            <a
              class="nav-link"
              [routerLink]="[ROUTES_PATH.USERS]"
              routerLinkActive="active highlight"
              [attr.data-qa]="testIdPrefix + '-users-management-link'"
            >
              <rx-icon name="personal-details" class="nav-icon nav-icon-personal" size="lg" />
              {{ t('userManagement') }}
            </a>
          </li>
        }
        @if (selfCustomFieldsEnabled()) {
          <li class="nav-item">
            <a
              class="nav-link"
              [routerLink]="[ROUTES_PATH.CUSTOM_FIELDS]"
              routerLinkActive="active highlight"
              [attr.data-qa]="testIdPrefix + '-custom-fields-link'"
            >
              <rx-icon name="briefcase" class="nav-icon" size="lg" fill="text-color" stroke="none" />
              {{ t('customFields') }}
            </a>
          </li>
        }

      }
      @if (allowCompanyPaymentPage()) {
        <li class="nav-item">
          <a
            class="nav-link"
            [routerLink]="[ROUTES_PATH.PAYMENT]"
            routerLinkActive="active highlight"
            [attr.data-qa]="testIdPrefix + '-payment-settings-link'"
          >
            <rx-icon name="wallet" class="nav-icon" size="lg" />
            {{ t('paymentSettings') }}
          </a>
        </li>
      }
    </ul>
  } @placeholder (minimum 300ms) {
    <rx-skeleton-grid
      [numberOfItems]="3"
      [numberOfColumns]="1"
      itemHeight="42px"
      columnGap="12px"
      [testId]="testIdPrefix + '-loading'"
    />
  }
</aside>
